import { MoneyRecord, PriceSale, SalesItemForBookingRecord } from '@navio/nsdk';
import {
  CarWithSalesItemsForNewBooking,
  FleetCarWithSalesItemProperties,
  ServiceItemsMappedForFleetWithCars
} from 'noddi-types';
import { formatCurrencyAmount } from 'noddi-util';

// Fleet view models carry a plain gross MoneyRecord; API records carry the full PriceSale
const toGross = (price: MoneyRecord | PriceSale): MoneyRecord => ('priceGross' in price ? price.priceGross : price);

/**
 * Base function to format price range for sales items
 * @param salesItems - Array of sales items with prices
 * @param fromLabel - The label to use for "from" (e.g., "from", t`from`)
 * @returns Formatted price string or undefined if no prices
 */
export const getPriceFormattedBase = (
  salesItems:
    | CarWithSalesItemsForNewBooking['salesItems']
    | ServiceItemsMappedForFleetWithCars[]
    | FleetCarWithSalesItemProperties[]
    | SalesItemForBookingRecord[],
  fromLabel: string
): string | undefined => {
  // Collect positive prices and check if all are equal
  const positivePrices = salesItems.map((item) => toGross(item.price).amount).filter((amount) => amount > 0);

  if (positivePrices.length === 0) {
    return undefined;
  }

  const minPrice = Math.min(...positivePrices);
  const maxPrice = Math.max(...positivePrices);

  const currency = salesItems[0] ? toGross(salesItems[0].price).currency : undefined;

  const formatted = formatCurrencyAmount({
    money: {
      amount: minPrice,
      currency
    },
    decimals: 0
  });

  // If all subitems share the same price, omit the "from" label
  return minPrice === maxPrice ? formatted : `${fromLabel} ${formatted}`;
};
